var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandSeoSettings24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "incon_seo_settings24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "growth",
    transform: "translate(4 4)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47000",
    "data-name": "Path 47000",
    d: "M5.5,22h-3a.5.5,0,0,1-.5-.5v-3a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v3A.5.5,0,0,1,5.5,22Z",
    transform: "translate(-.667 -6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47001",
    "data-name": "Path 47001",
    d: "M13.5,20.333h-3a.5.5,0,0,1-.5-.5V13.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v6.333A.5.5,0,0,1,13.5,20.333Z",
    transform: "translate(-3.333 -4.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47002",
    "data-name": "Path 47002",
    d: "M21.5,18.667h-3a.5.5,0,0,1-.5-.5V8.5a.5.5,0,0,1,.5-.5h3a.5.5,0,0,1,.5.5v9.667A.5.5,0,0,1,21.5,18.667Z",
    transform: "translate(-6 -2.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47003",
    "data-name": "Path 47003",
    d: "M10.166.1A.345.345,0,0,0,9.924,0,8.028,8.028,0,0,0,4.445,2.733a5.244,5.244,0,0,0-3.557,1.3.333.333,0,0,0,.158.56l1.419.34-.009.009a.333.333,0,0,0,.012.459l2.4,2.4a.334.334,0,0,0,.459.012L5.335,7.8l.34,1.419a.333.333,0,0,0,.234.243A.324.324,0,0,0,6,9.473a.335.335,0,0,0,.236-.1,5.244,5.244,0,0,0,1.3-3.557A8.033,8.033,0,0,0,10.264.339a.338.338,0,0,0-.1-.241Z",
    transform: "translate(-.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47004",
    "data-name": "Path 47004",
    d: "M1.144,10.144a10.059,10.059,0,0,0-1.13,2.673.333.333,0,0,0,.319.429.341.341,0,0,0,.1-.014A10.046,10.046,0,0,0,3.1,12.1a1.385,1.385,0,1,0-1.959-1.958Z",
    transform: "translate(0 -3.246)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12075",
    "data-name": "Rectangle 12075",
    width: 24,
    height: 24,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandSeoSettings24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brand_seo_settings24x24.f36e0734d29a4ab0579b8b50dff3166c.svg";